import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { HospitalService } from 'src/app/components/pages/_services';
import { AuthService } from 'src/app/modules/auth';
import { AuthModel } from 'src/app/modules/auth/_models/auth.model';
import { TranslationService } from '../../i18n/translation.service';
import { LabService } from '../../lab/_services';
import { ConfirmSaveModalComponent } from './confirm-save-modal/confirm-save-modal.component';

const x: Date = new Date();
const ngbDate: NgbDateStruct = {
  year: x.getFullYear(),
  month: x.getMonth()+1,
  day: x.getDate(),
}
@Component({
  selector: 'app-add-appointment',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})

export class AddComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  isLoading$: Observable<boolean>;
  errorMessage = '';
  private subscriptions: Subscription[] = [];
  user$: Observable<AuthModel>;
  roles: string[];
  errorMsg = '';
  Specialties$;
  Doctors$;
  PatientId;
  language: any;
  model: NgbDateStruct;
  DoctorSlots: any[] = [];
  SelectedDate;
  x: Date = new Date();
  Today = new Date(this.x.getFullYear(), this.x.getMonth(), this.x.getDate());
  SpecialtyId;
  DoctorId;
  PatientProfile;
  GuestProfile;
  GuestId;
  AboutDoctor:string = "";
  isOpen: boolean = false;

  constructor(
    private fb: FormBuilder,
    private HospitalService: HospitalService,
    private modalService: NgbModal,
    private LabService: LabService,
    private authService: AuthService,
    private router: Router, private translationService: TranslationService,
    private route: ActivatedRoute,
    private toast: HotToastService, private auth: AuthService) {
    this.user$ = this.auth.currentUserSubject.asObservable();
  }
  get FormGroupValue() {
    return this.formGroup.controls;
  }
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    const sb = this.user$.subscribe(res => {
      
      if (res?.userId) {
        this.roles = res.roles;
        if (res.isGuest && res.iqamaId != null && res.iqamaId != '') {
          this.GuestProfile = res;
          this.GuestId = res.userId;
          this.PatientId = null;
        }
        else {
          
          this.PatientId = res.userId;
          this.GuestId = 0;
          
        }
      }
    });
    this.subscriptions.push(sb);
    this.SpecialtyId = this.route.snapshot.params['specialtyId'];
    this.DoctorId = this.route.snapshot.params['doctorId'];
    this.LoadAllSpecialties();
    this.loadForm();
    this.isLoading$ = this.HospitalService.isLoading$;
    if (this.SpecialtyId != null) {
      this.Doctors$ = this.HospitalService.GetAllDoctorsByDepartmentId(this.SpecialtyId);
    }
    this.GetDoctorSlots();
    this.GetDoctorAbout(this.FormGroupValue.DoctorId.value);
  }
  togglePanel() {
    this.isOpen = !this.isOpen;
  }
  GetPatientProfile()
  {
    const sb = this.LabService.GetPatientProfile().subscribe(res => {
      
      if (res.data && res.data != null) {
        this.GuestProfile = null;
        this.PatientProfile = res.data;
      }
    })
    this.subscriptions.push(sb);
  }
  LoadAllSpecialties() {
    this.Specialties$ = this.HospitalService.GetHospitalDepartments();
  }
  GetDoctorAbout(DoctorId)
  {
    this.Doctors$.subscribe(res => {
    var doctors = res.filter(x => x.empId ==DoctorId);
    this.language == 'ar' ? this.AboutDoctor = doctors[0].aboutAr : this.AboutDoctor = doctors[0].aboutEn
    })
  }
  OnChangeSpecialty(event) {
    this.formGroup.patchValue({ DoctorId: '' })
    let SpecialtyId = event.target.options[event.target.options.selectedIndex].value;
    this.Doctors$ = this.HospitalService.GetAllDoctorsByDepartmentId(SpecialtyId);
  }
  GetDoctorSlots() {
    this.DoctorSlots = [];
    if (this.FormGroupValue.DoctorId.value && this.FormGroupValue.Date.value) {
      let FromDate = this.FormateDate(new Date(this.FormGroupValue.Date.value.year, this.FormGroupValue.Date.value.month - 1, this.FormGroupValue.Date.value.day));
      this.SelectedDate = FromDate;
      if (this.SelectedDate < this.Today) {
        if (this.language == "ar") {
          this.toast.warning("<b>يجب اختيار تاريخ مساويا لليوم او في المستقبل</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>You must choose a date equal to today or in the future</b>", { style: { padding: '20px' } });
        }
      }
      else {
        const sb = this.HospitalService.GetDoctorSlots(this.FormGroupValue.DoctorId.value, FromDate.toUTCString()).subscribe(res => {
          if (res.data != null && res.isSuccess) {
            this.DoctorSlots = res.data;
            if (this.PatientId && this.PatientId != 0){this.GetPatientProfile();}
          }
          else if (res.error?.status == 401) {
            var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
            let PatientId = this.PatientId;
            if (this.GuestId && this.GuestId != 0 && this.GuestId != null){PatientId=0}
            const RefreshToken = this.authService.RefreshToken(PatientId, this.GuestId, refreshToken).subscribe(resl => {
              if (resl.userId && resl.userId != 0 && resl.userId != null) {
                this.GetDoctorSlots();
              }
              else {
                if (this.language == "ar") {
                  this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
                }
                else {
                  this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
                }
              }
            });
            this.subscriptions.push(RefreshToken);
          }
          else {
            if (this.language == "ar") {
              this.toast.warning("<b>لا توجد مواعيد في هذا اليوم</b>", { style: { padding: '20px' } });
            }
            else {
              this.toast.warning("<b>There are no appointments on this day</b>", { style: { padding: '20px' } });
            }
          }
          this.GetDoctorAbout(this.FormGroupValue.DoctorId.value)

        });
        this.subscriptions.push(sb);
      }

    }
  }
  loadForm() {

    this.formGroup = this.fb.group({
      Id: [0],
      SpecialtyId: [this.SpecialtyId, Validators.required],
      DoctorId: [this.DoctorId, Validators.required],
      Date: [ngbDate, Validators.required],
      Today: [this.Today]
    });
  }
  SaveAppointment(Slot) {
    if (this.PatientProfile && this.PatientProfile != null || (this.GuestProfile && this.GuestProfile != null))
    {
      const modalRef = this.modalService.open(ConfirmSaveModalComponent);
      modalRef.componentInstance.Slot = Slot;
      modalRef.componentInstance.DoctorId = this.formGroup.controls.DoctorId.value;
      modalRef.componentInstance.DepartmentId = this.formGroup.controls.SpecialtyId.value;
      modalRef.componentInstance.PatientProfile = this.PatientProfile;
      modalRef.componentInstance.GuestProfile = this.GuestProfile;
    }
    else
    {
      sessionStorage.setItem('DepartmentId',this.SpecialtyId);
      sessionStorage.setItem('DoctorId',this.DoctorId.toString());
      this.router.navigate(['/login' ], { relativeTo: this.route });
      return
    }
   
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
    // sessionStorage.removeItem('DepartmentId');
    // sessionStorage.removeItem('DoctorId');
  }
  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string) {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
  FormateDate(RequestDate: Date) {
    RequestDate = new Date(RequestDate);
    let hoursDiff = RequestDate.getHours() - RequestDate.getTimezoneOffset() / 60;
    let minutesDiff = (RequestDate.getHours() - RequestDate.getTimezoneOffset()) % 60;
    RequestDate.setHours(hoursDiff);
    RequestDate.setMinutes(minutesDiff);
    return RequestDate;
  }
}
